import request from '@/utils/request'

//  保险列表
export const listInsurance = (pageData, formData) => {
  return request.post(`/insurance/page/${pageData.page}/${pageData.pageSize}`, formData)
}

//  保险详情
export const detailInsurance = (id) => {
  return request.get(`/insurance/${id}`)
}

//  新增保险
export const addInsurance = (formData) => {
  return request.post('/insurance', formData)
}

//  修改保险
export const editInsurance = (id, formData) => {
  return request.put(`/insurance/${id}`, formData)
}

// 修改保险上下架状态
export const putOnOrOffInsurance = (id, status) => {
  return request.put(`/insurance/insuranceState/${id}/${status}`)
}

// 删除保险
export const deleteInsurance = (id) => {
  return request.delete(`/insurance/${id}`)
}
